module.exports = __webpack_public_path__ + "images/cards/who-is.png";